import { useCallback, useEffect, useRef, useState } from 'react';

const useTextToSpeech = () => {
	const [isSpeaking, setIsSpeaking] = useState(false);
	const speechRef = useRef(null);

	useEffect(() => {
		if (!('speechSynthesis' in window)) {
			console.log('Speech synthesis is not supported in this browser.');
			return;
		}

		speechRef.current = window.speechSynthesis;
	}, []);

	useEffect(() => {
		return () => {
			if (speechRef.current) {
				speechRef.current.cancel();
			}
		};
	}, []);

	const speak = (text, language = 'sv-SE') => {
		if (!speechRef.current) {
			console.log('Speech synthesis is not available.');
			return;
		}

		if (!text) {
			console.log('No text provided for speech synthesis.');
			return;
		}

		speechRef.current.cancel();

		const utterance = new SpeechSynthesisUtterance(text);
		utterance.lang = language;
		utterance.rate = 1;
		utterance.pitch = 1;
		utterance.volume = 1;

		utterance.onstart = () => setIsSpeaking(true);
		utterance.onend = () => setIsSpeaking(false);

		try {
			speechRef.current.speak(utterance);
		} catch (error) {
			console.error('Error occurred while speaking:', error);
		}
	};

	const cancel = useCallback(() => {
		if (speechRef.current) {
			try {
				speechRef.current.cancel();
				setIsSpeaking(false);
			} catch (error) {
				console.error('Error occurred while cancelling speech:', error);
			}
		}
	}, []);

	return { speak, cancel, isSpeaking };
};

export default useTextToSpeech;
